import React from "react";
import { ReduxControls } from "rhombus-react";

import "./ColorInput.css";

export const ColorInput = (props) => {
	const { input = {}, className } = props;
	const { value } = input;
	const DEFAULT_COLOR = "#000000";
	React.useEffect(() => {
		if (value) {
			setCurrentSelectedColor(value);
		}
	}, [value]);
	const [currentSelectedColor, setCurrentSelectedColor] = React.useState(value ?? DEFAULT_COLOR);
	return (
		<div className={`color-input-container ${className}`} data-testid={"color-input-container"}>
			<ReduxControls.Input
				{...props}
				className={`color-picker-preview`}
				onChange={setCurrentSelectedColor}
			/>
			<span data-testid={"color-input-color-span"}>
				{currentSelectedColor}
			</span>
		</div>
	);
};

ColorInput.displayName = "ColorInput";
